module.exports = __webpack_public_path__ + "img/Fiji.ece5a244.gif";